/**
 * siteSettingsV2 keys that are edited in the server admin form. When both forms are populated
 * from APIs that return all settings, we filter so each form only receives the keys it owns.
 */
const SERVER_ADMIN_ONLY_SITE_SETTINGS_V2_KEYS = [] as const;

/**
 * Filter siteSettingsV2 to only include server-admin-only keys.
 * Use when populating the server admin form from getSiteSettingsForServerAdmin (which returns all settings).
 */
export function filterToServerAdminOnlySiteSettingsV2<T extends { siteSettingsV2?: Record<string, unknown> }>(data: T): T {
  if (!data.siteSettingsV2) {
    return data;
  }
  const filteredV2: Record<string, unknown> = {};
  for (const key of Object.keys(data.siteSettingsV2)) {
    if (SERVER_ADMIN_ONLY_SITE_SETTINGS_V2_KEYS.includes(key as typeof SERVER_ADMIN_ONLY_SITE_SETTINGS_V2_KEYS[number])) {
      filteredV2[key] = data.siteSettingsV2[key];
    }
  }
  return {
    ...data,
    siteSettingsV2: Object.keys(filteredV2).length > 0 ? filteredV2 : {}
  };
}

/**
 * Filter siteSettingsV2 to exclude server-admin-only keys.
 * Use when populating the site admin form when both forms are present (server admin scenario).
 */
export function filterOutServerAdminOnlySiteSettingsV2<T extends { siteSettingsV2?: Record<string, unknown> }>(data: T): T {
  if (!data.siteSettingsV2) {
    return data;
  }

  const filteredV2: Record<string, unknown> = {};
  for (const key of Object.keys(data.siteSettingsV2)) {
    if (!SERVER_ADMIN_ONLY_SITE_SETTINGS_V2_KEYS.includes(key as typeof SERVER_ADMIN_ONLY_SITE_SETTINGS_V2_KEYS[number])) {
      filteredV2[key] = data.siteSettingsV2[key];
    }
  }
  return {
    ...data,
    siteSettingsV2: Object.keys(filteredV2).length > 0 ? filteredV2 : {}
  };
}
